<template>
  <div class="notice">
    <template
      v-for="message in messages"
    >
      <div
        v-if="isHtmlMessage(message)"
        :key="message.id"
        :class="{ 'notice__message--error': message.type === 'error' }"
        class="notice__message"
        data-test="message-block"
        v-html="message.text"
      />
      <div
        v-else
        :key="message.id"
        :class="{ 'notice__message--error': message.type === 'error' }"
        class="notice__message"
        data-test="message-block"
      >
        {{ message.text }}
      </div>
    </template>
  </div>
</template>

<script>
import plugin from './plugin';
import { NoticeMarkup } from './types';

const uid = () => Math.random().toString(36).substr(2, 9);

export default {
  name: 'Notice',
  data() {
    return {
      messages: [],
    };
  },
  beforeMount() {
    plugin.emitter.$on('message', this.handleMessage);
  },
  beforeDestroy() {
    plugin.emitter.$off('message', this.handleMessage);
  },
  methods: {
    isHtmlMessage(message) {
      return message.markup === NoticeMarkup.HTML
    },
    handleMessage({ text, type, error, markup }) {
      const id = uid();
      this.messages.push({ id, text, type, markup, visible: true });
      if (type === 'error') {
        this.sendError(text, error || new Error(text));
      }

      setTimeout(() => {
        this.handleClear(id);
      }, 4000);
    },
    handleClear(id) {
      this.messages = this.messages.filter(m => m.id !== id);
    },
    sendError() {
      // Don't send UI errors to sentry, no sense
    },
  },
};
</script>

<style scoped lang="scss">
$color: $white;
$box-shadow: 0 0 16px 0 rgba($black, 0.12), 0 16px 16px 0 rgba($black, 0.24);
$notice-background: $primary;
$error-background: $pomegranate;

.notice {
  &__message {
    // fixme: no such typography mixin

    height: 64px;
    line-height: 64px;
    border-radius: 16px;
    box-shadow: $box-shadow;
    color: $color;
    font-weight: normal;
    position: fixed;
    font-size: 14px;
    z-index: 301;
    padding: 0 20px;
    right: 30px;
    top: 40px;
    animation: 4s ease-out 0s 1 slideInOutFromTop;
    animation-fill-mode: forwards;
    background-color: $notice-background;

    @keyframes slideInOutFromTop {
      0% {
        display: block;
        transform: translateY(-300px);
      }

      10% {
        transform: translateY(0);
      }

      90% {
        transform: translateY(0);
      }

      100% {
        transform: translateY(-300px);
      }
    }

    &--error {
      background-color: $error-background;
    }
  }
}
</style>
